"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conversationHash = void 0;
const tslib_1 = require("tslib");
const constants_1 = require("../constants");
const helpers_1 = require("../helpers");
const helpers_2 = require("./helpers");
/**
 * All chat messages are stored on IPFS. This function will return the latest message's CID (Content Identifier on IPFS).
 * Whenever a new message is sent or received, this CID will change.
 */
const conversationHash = (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { conversationId, account, env = constants_1.default.ENV.PROD } = options || {};
    try {
        if (!(0, helpers_1.isValidETHAddress)(account)) {
            throw new Error(`Invalid address!`);
        }
        const updatedConversationId = yield (0, helpers_2.getUserDID)(conversationId, env);
        const accountDID = yield (0, helpers_2.getUserDID)(account, env);
        const response = yield (0, helpers_2.getConversationHashService)({
            conversationId: updatedConversationId,
            account: accountDID,
            env,
        });
        return response;
    }
    catch (err) {
        console.error(`[Push SDK] - Error - API ${exports.conversationHash.name} - `, err);
        throw Error(`[Push SDK] - Error - API ${exports.conversationHash.name} - `);
    }
});
exports.conversationHash = conversationHash;
//# sourceMappingURL=conversationHash.js.map